import React from 'react';
import { WidgetBoxDivider, WidgetBoxFirstLayer } from '../../../svg/TemplateIcons';

const WidgetToolbox = ({
  t,
  widgetSearchQuery,
  setWidgetSearchQuery,
  filteredWidgetOptions,
}) => (
  <div className='widgets-box'>
    <div className='widgets-box-header'>
      <div className='widget-box-icon'>
        <div className='widget-box-icon-layer widget-box-icon-base' />
        <div className='widget-box-icon-layer widget-box-icon-layer-5' />
        <div className='widget-box-icon-layer widget-box-icon-layer-4' />
        <div className='widget-box-icon-layer widget-box-icon-layer-3' />
        <div className='widget-box-icon-layer widget-box-icon-layer-2' />
        <div className='widget-box-icon-layer widget-box-icon-layer-1'>
          <WidgetBoxFirstLayer />
        </div>
      </div>

      <h2 className='widgets-box-title'>{t.widgetBoxTitle}</h2>
    </div>

    <WidgetBoxDivider />

    <div className='widgets-box-search'>
      <input
        type='search'
        className='widgets-box-search-input'
        value={widgetSearchQuery}
        onChange={(event) => setWidgetSearchQuery(event.target.value)}
        placeholder={t.widgetSearchPlaceholder || 'Search widgets'}
        aria-label={t.widgetSearchPlaceholder || 'Search widgets'}
      />
    </div>

    <div className='widgets-list'>
      {filteredWidgetOptions.length > 0
        ? filteredWidgetOptions.map(w => w)
        : (
          <div className='widgets-box-empty'>
            {t.widgetSearchEmpty || 'No widgets found'}
          </div>
        )}
    </div>
  </div>
);

export default WidgetToolbox;
